import { SNOWPLOW_APP_ID, SNOWPLOW_TRACKER_NAME } from '@/constants/snowplow';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { AuthenticatedSnowplow as SharedAuthenticatedSnowplow } from '@montugroup/circuit-shared';
import { featureFlagFilters } from '@montugroup/data-collection';
import React from 'react';

export const AuthenticatedSnowplow = (props: React.PropsWithChildren) => {
  const { children } = props;
  const { flags } = useFeatureFlags();

  return (
    <SharedAuthenticatedSnowplow
      appId={SNOWPLOW_APP_ID}
      trackerName={SNOWPLOW_TRACKER_NAME}
      flags={flags}
      featureFlagFilter={featureFlagFilters.all}
    >
      {children}
    </SharedAuthenticatedSnowplow>
  );
};

export default AuthenticatedSnowplow;
